"use strict";

module.exports = /* @ngInject */ function() {
  var that = this;
  var usingRocc = false;

  that.isUsingRocc = function() {
    return usingRocc;
  };

  that.setUsingRocc = function(isRocc) {
    usingRocc = isRocc;
  };
};



// WEBPACK FOOTER //
// ./app/infrastructure/roccUsageRepository.js